/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, IntlShape} from 'react-intl';
import {viewWithDataGetPrimaryData} from '../box-utils/PrimaryData';
import {ParentBox, relayWrap} from './../box-utils/ParentBox.react.js';
import BoxDecorator from './../box-utils/BoxDecorator.react';
import EmptyContent from './system/EmptyContent.react';
import PanelColumns from './system/PanelColumns.react';
import {getImageByImgEl} from './getImage';
import './LogoBox.scss';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

class LogoBox extends ParentBox {

    static handlerName = "logobox";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

	constructor(props) {
		super(props);

		let data = this.props.isPreview ? this.getPreviewData() : this.getData();
		let images = {};

		data.forEach(row => {
			images[row.id] = {loading: true};
			this.startLoadingLogo(row);
		});

		this.state = {
			loading: true,
			noneFound: true,
			images: images
		};
	}

    getIcon() {
        return "logobox";
    }

	getServiceName() {
		return "LOGOBOX";
	}

	getPreviewData() {
		return [
			{
				name: 'Firma s.r.o.',
				id: 'CZ05574617',
			}
		];
	}

	getData() {
		let {addon} = this.props.viewWithData;
		addon = safeJSONparse(addon);

		if (addon && addon.merk && addon.merk.length > 0) {
			return addon.merk.map((item) => {
				let id = null;

				if (item.basic && item.basic.regno && item.basic.address && item.basic.address.country_code) {
					id = item.basic.address.country_code + item.basic.regno;
				}
				else if (item.basic && item.basic.vatno) {
					id = item.basic.vatno;
				}
				else if (item.basic && item.basic.regno) {
					id = item.basic.regno;
				}

				if (id) {
					return {
						name: item.basic.name,
						id: id
					};
				}
				return null;
			}).filter((item) => {
				return item !== null;
			});
		}

		let data = viewWithDataGetPrimaryData(this.props.viewWithData);

		return data.map((row) => {
			let identNum = row['com.dativery.model.entities.companies@euVatNumber'];

			if (!identNum) {
				identNum = (
						row['com.dativery.model.components.seatAddresses@saCountryCode'] ||
						'cz'
					) + (
						row['com.dativery.model.components.company.registrationNumbers@czRN'] ||
						row['com.dativery.model.components.company.registrationNumbers@skRN'] ||
						row['com.dativery.model.components.company.registrationNumbers@unRN']
					);
			}

			let name = row['com.dativery.model.entities.companies@name'];

			return {
				name: name,
				id: identNum
			};
		}).filter((row) => row.id);
	}

	startLoadingLogo(row) {
		getImageByImgEl('logobox', row.id).then((imgBlobSrc) => {
			let images = this.state.images;
			images[row.id] = { loading: false, notFound: false, imgSrc: imgBlobSrc, data: row };

			this.setState({
				images: images,
				noneFound: false,
				loading: !this.allImagesLoaded(images)
			});
		}).catch(() => {
			let images = this.state.images;
			images[row.id] = { loading: false, notFound: true };

			this.setState({
				images: images,
				loading: !this.allImagesLoaded(images)
			});
		});
	}

	allImagesLoaded(images) {
		images = images || this.state.images;
		return !Object.keys(images).some(key => images[key].loading === true);
	}

    render() {
		if (this.state.loading) {
			return (
				<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} ref="boxElement" title={this.getServiceName()}>
					<EmptyContent message={<FormattedMessage defaultMessage="Loading" id="googleMapsBox.loading" />} />
				</BoxDecorator>
			);
		}

		if (this.state.noneFound) {
			return (
				<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} ref="boxElement" title={this.getServiceName()}>
					<EmptyContent message={<span><FormattedMessage defaultMessage="No logo found in {appName}" id="logobox.notFound" values={{appName: this.getServiceName()}} /></span>} />
				</BoxDecorator>
			);
		}

        return (
            <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
				<PanelColumns className="narrow-columns">
					{Object.keys(this.state.images).filter(key => !this.state.images[key].notFound).sort((keyA, keyB) => {
						return this.state.images[keyA].data.name.localeCompare(this.state.images[keyB].data.name);
					}).map(key => {
						let row = this.state.images[key];

						return (
							<div className="LogoBoxImage" key={key}>
								<div className="item">
									<img className="dativeryValue" key={key} src={row.imgSrc} title={row.data.name}/><br />
									<small className="dativeryValue">{row.data.name}</small>
								</div>
							</div>
						);
					})}
				</PanelColumns>
            </BoxDecorator>
        );
    }
}

export default relayWrap(LogoBox);
